import { type ReactNode, type Ref, useContext, useState } from "react";
import { View as RNView } from "react-native";

import { View, XStack, YStack } from "@/components";
import { LayoutContext } from "@/components/LayoutProvider";
import { Text } from "@/components/Typography";
import ExpandableCard from "../ExpandableCard";
import SectionHeader from "./SectionHeader";

export type FAQItem = {
  question: string;
  answer: string | ReactNode;
  paymentQuestion?: string;
  paymentAnswer?: string | ReactNode;
};

type FAQProps = {
  ref?: Ref<RNView>;
  items: FAQItem[];
  paymentsEnabled?: boolean;
};

function FAQ({ ref, items, paymentsEnabled = false }: FAQProps) {
  const [expandedItem, setExpandedItem] = useState<number | null>(0);
  const { lg } = useContext(LayoutContext);
  const faqBlock = items.map(
    ({ question, answer, paymentQuestion, paymentAnswer }, index) => {
      const displayedQuestion =
        paymentsEnabled && paymentQuestion ? paymentQuestion : question;
      const displayedAnswer =
        paymentsEnabled && paymentAnswer ? paymentAnswer : answer;
      const title = (
        <Text size="$lg" medium paddingVertical="$300">
          {displayedQuestion}
        </Text>
      );
      const content =
        typeof displayedAnswer === "string" ? (
          <Text marginBottom="$300">{displayedAnswer}</Text>
        ) : (
          displayedAnswer
        );
      return (
        <ExpandableCard
          key={question}
          backgroundColor="$transparent"
          toggleIconType="chevron"
          title={title}
          content={content}
          borderRadius={0}
          borderTopWidth={index === 0 ? 1 : 0}
          borderBottomWidth={1}
          borderColor="$fillNeutral"
          isExpanded={expandedItem === index}
          onToggle={() => setExpandedItem(index)}
        />
      );
    },
  );

  if (lg) {
    return (
      <XStack
        maxWidth="$landingPageConstraint"
        alignSelf="center"
        paddingHorizontal="$250"
        gap="$800"
      >
        <View width="40%" flex={1}>
          <SectionHeader
            ref={ref}
            textInPrimaryColor="Frequently asked questions"
          />
        </View>
        <View width="50%" flex={1}>
          {faqBlock}
        </View>
      </XStack>
    );
  }

  return (
    <YStack
      maxWidth="$landingPageConstraint"
      alignSelf="center"
      paddingHorizontal="$250"
    >
      <SectionHeader
        ref={ref}
        textInPrimaryColor="Frequently asked questions"
        marginBottom="$500"
      />
      {faqBlock}
    </YStack>
  );
}

export default FAQ;
